var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticStyle: {
      "max-height": "400px",
      "overflow-y": "auto",
      "width": "100%"
    }
  }, [_c('canvas', {
    ref: "canvas",
    attrs: {
      "height": "400"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }